import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider } from "@fluentui/react-components";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import { knoweeDarkTheme, knoweeLightTheme } from "./theme/knowee";
import { useStateStore } from "../store";

const rootElement: HTMLElement = document.getElementById("container");
const root = createRoot(rootElement);

initializeIcons();

const ThemeWrapper = (props: any) => {
  console.log(props); // Usamos props en este console.log para evitar error de compilación
  const { isDarkMode, setIsDarkMode } = useStateStore();

  React.useEffect(() => {
    const handleChange = (e: { matches: boolean }) => {
      setIsDarkMode(e.matches);
    };
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [setIsDarkMode]);

  return (
    <FluentProvider theme={isDarkMode ? knoweeDarkTheme : knoweeLightTheme}>
      <App />
    </FluentProvider>
  );
};

Office.onReady(() => {
  root.render(<ThemeWrapper />);
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root.render(
      <ThemeWrapper>
        <NextApp />
      </ThemeWrapper>
    );
  });
}
